import { render, staticRenderFns } from "./EmailBox.vue?vue&type=template&id=2524c809&scoped=true"
import script from "./EmailBox.vue?vue&type=script&lang=js"
export * from "./EmailBox.vue?vue&type=script&lang=js"
import style0 from "./EmailBox.vue?vue&type=style&index=0&id=2524c809&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2524c809",
  null
  
)

export default component.exports